<div class="profile-container">
  <div class="">
      <div class="profile-content">
          <div class="personal-details">
              <div class="header-block">
              <div class="header-title">
                <app-breadcrumb></app-breadcrumb>
              </div>
              <div class="add-block">
                <div class="search">
                  <form autocomplete="off">
                    <input type="text" placeholder="search" (keyup.enter)="getAllByWildSearch()" [ngModelOptions]="{standalone: true}" [(ngModel)]="searchKey">
                  </form>
                  <i class="bi bi-search" (click)="getAllByWildSearch()"></i>
                </div>
                <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{ 'generic.add' | translate }}</button>
              <div class="filter-icon">
                  <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                </div>
              </div>
            </div>
            
              <table class="table table-striped">
                  <thead>
                      <tr>
                      <th style="width: 25%;">Priority Status</th>
                      <th style="width: 25%;">Time In Hrs</th>
                      <th style="width: 30%;">Description</th>
                      <th style="width: 20%;text-align: center;padding: 0;" class="">{{ 'generic.action' | translate }}</th>
                      </tr>
                  </thead>
              </table>
              <div *ngIf="!isLoading">
                  <div class="data-view" *ngFor="let ticket of ticketPriorityData | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: page,
                      totalItems: count
                      }  ;let i = index">
      
                      <p style="width: 25%;">{{ticket.priorityStatus}}</p>
                      <p style="width: 25%;">{{ticket.timeInHrs}}</p>
                      <p style="width: 30%;">{{ticket.description}}</p>         
                      <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                          <i *ngIf="actionControls.isView" (click)="getTicketPriorityDefinitionById(ticket.id)" title="View" class="bi bi-eye" data-toggle="modal" data-target="#exampleModalView"></i>
                          <i *ngIf="actionControls.isModify" (click)="getTicketPriorityDefinitionById(ticket.id)" title="Edit" class="bi bi-pencil" data-toggle="modal" data-target="#editModal"></i>
                          <i *ngIf="actionControls.isDelete" (click)="selectDelete(ticket.id,ticket)" title="Delete" class="bi bi-trash" data-toggle="modal" data-target="#deleteModal"></i>
                      </p>                
                  </div>
              </div>
      
              <div class="loader" *ngIf="isLoading">
                  <div class="spinner"></div>
              </div>
      
              <div class="loader"  *ngIf="!isLoading && ticketPriorityData.length == 0">
                  <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                  </div>
              </div>
      
              <div class="paginator">
                  <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
                      [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
              </div>
          </div>
      </div>
  </div>
</div>

<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalLabel">{{ 'generic.add' | translate }} Ticket Priority
          <span data-dismiss="modal">
              <i (click)="formReset()" class="bi bi-x-lg"></i>
          </span>
      </h5>
    </div>
    <div class="modal-body">
      <div [formGroup]="form">
          <div class="row">
              <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                      <label>Priority Status <span class="required">*</span></label>
                      <input formControlName="priorityStatus" type="text" class="form-control">
                  </div>
              </div>
              <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                      <label>Time In Hrs <span class="required">*</span></label>
                      <input formControlName="timeInHrs" type="number" min="0" class="form-control">
                  </div>
              </div>
              
              <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                      <label>Description</label>
                      <textarea class="form-control" formControlName="description" cols="30" rows="10"></textarea>
                  </div>
              </div>
          </div>
      </div>
    <div class="modal-footer">
      <button type="button" id="closeModalButton" (click)="formReset()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
      <button type="button" (click)="addTicketPriority()" class="btn btn-primary">{{ 'generic.add' | translate }}</button>
    </div>
  </div>
</div>
</div>
</div>


<div class="modal fade" id="editModal" tabindex="-1" data-backdrop="static" aria-labelledby="editModalLabel" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="editModalLabel">{{ 'generic.edit' | translate }} Ticket Priority
          <span data-dismiss="modal">
              <i (click)="formReset()" class="bi bi-x-lg"></i>
          </span>
      </h5>
    </div>
    <div class="modal-body">
      <div [formGroup]="editForm">
          <div class="row">
              <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                      <label>Priority Status <span class="required">*</span></label>
                      <input formControlName="priorityStatus" type="text" class="form-control">
                  </div>
              </div>
              <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                      <label>Time In Hrs <span class="required">*</span></label>
                      <input formControlName="timeInHrs" type="number" min="0" class="form-control">
                  </div>
              </div>
              
              <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                      <label>Description</label>
                      <textarea class="form-control" formControlName="description" cols="30" rows="10"></textarea>
                  </div>
              </div>
          </div>
      </div>
    <div class="modal-footer">
      <button type="button" id="closeModalButton2" (click)="formReset()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
      <button type="button" (click)="updateTicketPriority()" class="btn btn-primary">{{ 'generic.update' | translate }}</button>
    </div>
  </div>
</div>
</div>
</div>

<div class="modal fade" id="exampleModalView" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabelView" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabelView">{{ 'generic.detail' | translate }} Ticket Priority
          <span data-dismiss="modal">
              <i class="bi bi-x-lg"></i>
          </span>
        </h5>
      </div>
      <div class="modal-body view">
        <div *ngFor="let item of singleTicketPriority">
            <div class="row">
                <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Priority Status</label>
                        <input type="text" [value]="item.priorityStatus" readonly class="form-control">
                    </div>
                </div>
                <div class="col-md-6 col-lg-6">
                    <div class="form-group">
                        <label>Time In Hrs</label>
                        <input type="number" [value]="item.timeInHrs" readonly class="form-control">
                    </div>
                </div>
                
                <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                        <label>Description</label>
                        <textarea class="form-control" [value]="item.description" readonly cols="30" rows="10"></textarea>
                    </div>
                </div>
            </div>
        </div>
      <div class="modal-footer">
        <button type="button" id="closeModalButton1" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
      </div>
    </div>
  </div>
  </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
        <span data-dismiss="modal">
          <i class="bi bi-x-lg" (click)="closeModal()"></i>
        </span>
      </h5>
    </div>
    <div class="modal-body">
      <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}}”</span>?</p>
      <div class="modal-footer">
        <button type="button" id="deleteModalButton" (click)="closeModal()" class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
        <button type="button" (click)="deleteTicketPriorityDefinition()" class="btn btn-primary">{{ 'generic.delete' | translate }}</button>
      </div>
    </div>
  </div>
</div>
</div>
